var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg065PriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.71 2.28996C12.5213 2.10277 12.2658 1.99842 12 1.99996H3.00002C2.44773 1.99996 2.00002 2.44767 2.00002 2.99996V12C1.99848 12.2658 2.10283 12.5212 2.29002 12.71L12.29 22.71C12.4778 22.8993 12.7334 23.0058 13 23.0058C13.2667 23.0058 13.5223 22.8993 13.71 22.71L22.71 13.71C22.8993 13.5222 23.0058 13.2666 23.0058 13C23.0058 12.7333 22.8993 12.4777 22.71 12.29L12.71 2.28996ZM13 20.59L4.00002 11.59V3.99996H11.59L20.59 13L13 20.59ZM7.50003 8.99997C8.32846 8.99997 9.00003 8.3284 9.00003 7.49997C9.00003 6.67154 8.32846 5.99997 7.50003 5.99997C6.67161 5.99997 6.00003 6.67154 6.00003 7.49997C6.00003 8.3284 6.67161 8.99997 7.50003 8.99997Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg065PriceTag);
export default __webpack_public_path__ + "static/media/065-price-tag.aa7158c97c346754afa4e54d1b8812c0.svg";
export { ForwardRef as ReactComponent };